import React, { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { ReactTitle } from "react-meta-tags";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Selector from "canvas-core-react/lib/Selector";
import TextField from "canvas-core-react/lib/TextField";
import IconAddNew from "canvas-core-react/lib/IconAddNew";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

import config from "../../utils/config.json";
import useApi from "../../hooks/useApi";
import Modal from "../../utils/customModal";
import {
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../utils/functions";

import MainTemplate from "../mainTemplate";
import { MOD_RELATIONS, WRITE } from "../../../permissions";
import { getRoles, getSessionCountry } from "../../../Redux/reducer/session";
import AccountTypeSelect, {
  VALUE_ACCOUNT_TYPE,
} from "../../shared/AccountTypeSelect";

export const format = (data) => {
  let detail = "";

  if (data.totalLines === data.totalLinesOk) {
    detail = (
      <p>
        La Modificación fue realizada con éxito.{" "}
        <strong>
          Este cambio entrará en vigencia cuando los clientes acepten la
          actualización de la cuenta.
        </strong>
      </p>
    );
  } else {
    detail = (
      <>
        <p>Se presentaron los siguientes errores:</p>
        <ul>
          {data.details.map(({ message }, key) => (
            <li key={`res-${key}`}>{message}</li>
          ))}
        </ul>
      </>
    );
  }

  return detail;
};

export const renderProfileForm = (account) => {
  const getValue = (name) => {
    if (account.accountType === VALUE_ACCOUNT_TYPE.LOCAL)
      return name === "bicDestinationBank" ? account[name] : defaultMessage;

    return account.accountType === VALUE_ACCOUNT_TYPE.BNS
      ? defaultMessage
      : account[name];
  };

  const form = (
    <Fragment key={`account-${account.id}`}>
      <Column lg={6}>
        <AccountTypeSelect
          id="accountType"
          className="default-selector"
          disabled={true}
          value={account.accountType}
        />
      </Column>
      <Column lg={6}>
        <TextField
          id="accountNumber"
          label="Número de Cuenta"
          value={account.accountNumber || ""}
          disabled={true}
        />
      </Column>
      <Column lg={6}>
        <TextField
          id="accountCurrency"
          label="Moneda"
          value={account.accountCurrency || ""}
          disabled={true}
        />
      </Column>
      {bicItems.map(({ id, label }) => (
        <Column lg={6} key={id}>
          <TextField
            id={id}
            label={label}
            value={getValue(id)}
            disabled={true}
          />
        </Column>
      ))}
    </Fragment>
  );

  return form;
};

const RelationDetail = () => {
  const { companyId, currency } = useParams();
  const history = useHistory();
  const [disabled, setDisabled] = useState(true);
  const roles = useSelector((state) => getRoles(state));
  const country = useSelector((state) => getSessionCountry(state));
  const [achAccounts, setAchAccounts] = useState([]);
  const { getApiCAll, postApiCAll, cancellCall } = useApi();
  const [data, setData] = useState({});
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  const [modifyAccount, setModifyAccount] = useState([]);

  useEffect(() => {
    getDetail();

    return () => cancellCall();
  }, []);

  useEffect(() => {
    if (data.countryCode === "PA") {
      getApiCAll(`/banks/bank-ach/${country}`).then((response) =>
        setAchAccounts(response.data.data)
      );
    }

    return () => cancellCall();
  }, [data]);

  const getDetail = () => {
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    getApiCAll(`/providers/detail-Relationship/${companyId}/${currency}`)
      .then((response) => {
        const data = response.data.data;
        const tmpModifyAccount = [];

        setData(data);
        data.currentAccountList.map(
          (item, idx) => (tmpModifyAccount[idx] = { accountId: item.id })
        );
        setModifyAccount(tmpModifyAccount);

        closeModal();
      })
      .catch(() => {
        let button = {
          formBtn: {
            text: "Cerrar",
            action: () => history.push("/providerSite/relations"),
          },
        };
        let content = sucessInfoModal(
          "Perfil de cuentas",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          button
        );
        setModal({
          show: true,
          content,
          onClose: () => history.push("/providerSite/relations"),
        });
      });
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const onChangeModifyAccount = (e, idx, check = false) => {
    const tmpAccount = [...modifyAccount];
    if (check) {
      tmpAccount[idx][e.target.name] = e.target.checked;
    } else {
      if (e.target.value !== "") {
        tmpAccount[idx][e.target.name] = e.target.value;
      } else {
        delete tmpAccount[idx][e.target.name];
      }
    }

    setModifyAccount(tmpAccount);
  };

  const getBicDestination = ({ accountType, bicDestinationBank }) => {
    return data.countryCode === "PA" && accountType === VALUE_ACCOUNT_TYPE.LOCAL
      ? achAccounts.find(
          ({ idBankShort }) => idBankShort === bicDestinationBank
        )?.bankName
      : bicDestinationBank;
  };

  const renderForm = () => {
    return data.currentAccountList.map((account, idx) => {
      const accountData = {
        ...account,
        bicDestinationBank: getBicDestination(account),
      };
      return disabled
        ? renderProfileForm(accountData)
        : renderEditForm(accountData, idx);
    });
  };

  const renderEditForm = (account, idx) => {
    return (
      <Fragment key={`account-${account.id}`}>
        <Column lg={6} md={6} lgOffset={0}>
          <Row nested>
            <Column lg={6}>
              <AccountTypeSelect
                id="accountTypeCurrent"
                name="accountTypeCurrent"
                className="default-selector"
                value={account.accountType}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <AccountTypeSelect
                id="accountType"
                name="accountType"
                className="default-selector"
                value={modifyAccount[idx].accountType || ""}
                onChange={(e) => onChangeModifyAccount(e, idx)}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumberCurrent"
                name="accountNumberCurrent"
                label="Número de Cuenta"
                value={account.accountNumber || ""}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumber"
                label="Número de Cuenta Nuevo"
                name="accountNumber"
                value={modifyAccount[idx].accountNumber || ""}
                onChange={(e) => onChangeModifyAccount(e, idx)}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBankCurrent"
                name="accountIntermediaryBankCurrent"
                label={"Cuenta Banco Destino\ncon Intermediario"}
                value={account.accountIntermediaryBank || ""}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBank"
                name="accountIntermediaryBank"
                label={"Cuenta Banco Destino\ncon Intermediario Nueva"}
                value={modifyAccount[idx].accountIntermediaryBank || ""}
                onChange={(e) => onChangeModifyAccount(e, idx)}
                disabled={
                  modifyAccount[idx].accountType !== undefined
                    ? modifyAccount[idx].accountType !== "INT"
                    : account.accountType !== "INT"
                }
              />
            </Column>
          </Row>
        </Column>
        <Column lg={6} md={6} lgOffset={0}>
          <Row nested>
            <Column lg={6}>
              <TextField
                id="bicDestinationBankCurrent"
                name="bicDestinationBankCurrent"
                label="Bic Banco Destino"
                value={account.bicDestinationBank || ""}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              {data.countryCode === "PA" &&
              modifyAccount[idx].accountType === "LOCAL" ? (
                <Selector
                  id="bicDestinationBank"
                  label="Bic Banco Destino Nueva"
                  name="bicDestinationBank"
                  onChange={(e) => onChangeModifyAccount(e, idx)}
                  value={modifyAccount[idx].bicDestinationBank || ""}
                >
                  {achAccounts.map((bank, idx) => (
                    <option key={`types-${idx}`} value={bank.idBankShort}>
                      {bank.bankName}
                    </option>
                  ))}
                </Selector>
              ) : (
                <TextField
                  id="bicDestinationBank"
                  name="bicDestinationBank"
                  label="Bic Banco Destino Nueva"
                  value={modifyAccount[idx].bicDestinationBank || ""}
                  onChange={(e) => onChangeModifyAccount(e, idx)}
                  disabled={
                    modifyAccount[idx].accountType !== undefined
                      ? modifyAccount[idx].accountType !== "INT"
                      : account.accountType !== "INT"
                  }
                />
              )}
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBankCurrent"
                name="bicIntermediaryBankCurrent"
                label="Bic Banco Intermediario"
                value={account.bicIntermediaryBank || ""}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBank"
                name="bicIntermediaryBank"
                label="Bic Banco Intermediario Nueva"
                value={modifyAccount[idx].bicIntermediaryBank || ""}
                onChange={(e) => onChangeModifyAccount(e, idx)}
                disabled={
                  modifyAccount[idx].accountType !== undefined
                    ? modifyAccount[idx].accountType !== "INT"
                    : account.accountType !== "INT"
                }
              />
            </Column>
            <Column lg={6}>
              <Selector
                id="accountCurrencyCurrent"
                name="accountCurrencyCurrent"
                label={"Moneda\n\n"}
                className="default-selector"
                disabled={true}
                value={account.accountCurrency}
              >
                {config[country].currency.map((currency, idx) => (
                  <option key={`types-${idx}`} value={currency.value}>
                    {currency.name}
                  </option>
                ))}
              </Selector>
            </Column>
          </Row>
        </Column>
      </Fragment>
    );
  };

  const enableSendButton = () => {
    let data = modifyAccount.filter((account) => {
      return Object.keys(account).length > 1;
    });
    return data.length > 0;
  };

  const save = () => {
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    let data = modifyAccount.filter(
      (account) => Object.keys(account).length > 1
    );

    postApiCAll(`/providers/modify-account/${companyId}/${currency}`, data, {})
      .then((response) => {
        getModalResponse(response.data.data);
      })
      .catch(() => {
        let button = { formBtn: { text: "Cerrar", action: closeModal } };
        let content = sucessInfoModal(
          "Datos de la cuenta de liquidación",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          button
        );
        setModal({ show: true, content, onClose: closeModal });
      });
  };

  const getModalResponse = (data) => {
    let button = { formBtn: { text: "Aceptar", action: closeAndReset } };

    let content = sucessInfoModal(
      "Datos de la cuenta de liquidación",
      format(data),
      button
    );

    setModal({ show: true, content, onClose: closeAndReset });
  };

  const closeAndReset = () => {
    closeModal();
    setDisabled(true);
    getDetail();
  };

  return (
    <MainTemplate className="wrapper-dashboard">
      <ReactTitle title={`Clientes relacionados - Reverse Factoring`} />
      {data.currentAccountList && (
        <div className="profile">
          <div className="actions-title">
            <h3>PERFIL DE LA RELACIÓN / DETALLE DE RELACIÓN ACTIVA</h3>
            {moduleAction(roles, MOD_RELATIONS, WRITE) && disabled && (
              <div
                className="new-edit-div"
                style={{ cursor: "pointer" }}
                onClick={() => setDisabled(false)}
              >
                <p className="new-edit-provider">Editar</p>
                <IconAddNew style={{ color: "#009DD6" }} />
              </div>
            )}
          </div>
          <Grid fluid={true}>
            <Row>
              <Column lg={6}>
                <TextField
                  id="companyName"
                  label="Nombre de la empresa relacionada"
                  value={data.companyName}
                  disabled={true}
                />
              </Column>
              <Column lg={6}>
                <TextField
                  id="companyId"
                  label="Identificación"
                  value={data.identification}
                  disabled={true}
                />
              </Column>
            </Row>
          </Grid>
          <h3>Datos de la cuenta de liquidación</h3>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              {renderForm()}
            </Row>
          </Grid>
          <div className="form-actions clearfix">
            <SecondaryButton
              onClick={() => history.push("/providerSite/relations")}
            >
              Atrás
            </SecondaryButton>
            {!disabled && enableSendButton() && (
              <SecondaryButton id="save-btn" onClick={save}>
                Enviar
              </SecondaryButton>
            )}
          </div>
        </div>
      )}
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </MainTemplate>
  );
};

export default RelationDetail;

const bicItems = [
  {
    id: "bicDestinationBank",
    label: "Bic Banco Destino",
  },
  {
    id: "bicIntermediaryBank",
    label: "Bic Banco Intermediario",
  },
  {
    id: "accountIntermediaryBank",
    label: "Cuenta Banco Destino con Intermediario",
  },
];

const defaultMessage = "No aplica";
